module.exports = __webpack_public_path__ + "img/content2.3178aab9.png";